module.exports = __webpack_public_path__ + "static/media/iv_chat_attachment.d9d76290.svg";